<template>
	<div>
		<v-tabs
			class="d-print-none"
			:value="tab"
			color="#00AAFD"
			background-color="#192A3E"
			centered
			dark
			@change="onChange"
		>
			<v-tab v-for="tab_item in tabs" :key="tab_item.key" :href="`#${tab_item.text}`">
				{{ tab_item.text }}
			</v-tab>
		</v-tabs>
	</div>
</template>
<script>
// Approve expense claim privilege
const AECP = 'Secap';

// Edit expense claim privilege
const EECP = 'Secapa';

const TABS = [
	{
		key: 'expenses',
		text: 'Expenses',
	},
	{
		key: 'claims',
		text: 'Claims',
	},
	{
		key: 'approvals',
		text: 'Manager Review',
	},
	{
		key: 'finance',
		text: 'Finance',
	}
];

export default {
	name: 'ExpensesTabs',
	props: {
		tab: {
			type: String,
			default: 'Expenses'
		}
	},
	data() {
		return {
			privileges: [],
			tabs: []
		}
	},
	async created() {
		if (this.$store.state.privileges && this.$store.state.privileges.length === 0) {
			await this.initPrivileges();
		} else {
			this.privileges = this.$store.state.privileges.filter(p => { return p.startsWith('S')});
		}
		await this.load_postseperately();
	},
	methods: {
		async initPrivileges() {
			const url = "/api/user/me/privileges";
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}					
				})
				.then(val => {
					const {status, data}  = val.data;

					if (status === "OK") {
						this.privileges = data.filter(p => { return p.startsWith('S')});
					}
				})
				.catch((e) => {
					console.log(e.message);
				});
		},
		async load_postseperately() {
			const url = "/api/expenses/claims/meta";
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const webclaim_postseperately = data.webclaim_postseperately === 0 ? false: true;

						let tabs = [];
						if (this.privileges.includes(AECP) && this.privileges.includes(EECP)) {
							if (webclaim_postseperately) {
								tabs = TABS;
							} else {
								tabs = TABS.filter(t => { return t.key !== 'approvals'});
							}
						}

						if (this.privileges.includes(AECP) && !this.privileges.includes(EECP)) {
							if (webclaim_postseperately) {
								tabs = TABS.filter(t => { return t.key !== 'finance'});
							} else {
								tabs = TABS.filter(t => { return t.key !== 'approvals' && t.key !== 'finance'});
							}
						} 

						if (!this.privileges.includes(AECP) && !this.privileges.includes(EECP)) {
							tabs = TABS.filter(t => { return t.key !== 'approvals' && t.key !== 'finance'});
						}
						this.tabs = tabs;
					} else {
						console.log('error-reason:', reason);
					}
				})
				.catch(e => {
					console.log('e.message:', e.message);
				});
		},
		onChange(tab_id) {
			this.$emit('tab', tab_id);
		},
	}
}
</script>